import { useMemo } from 'react'

import { isDocumentTypeCreditNote } from '@features/invoices/utils/isDocumentTypeCreditNote'
import { isDocumentTypeInvoice } from '@features/invoices/utils/isDocumentTypeInvoice'
import { isDocumentTypeQuote } from '@features/invoices/utils/isDocumentTypeQuote'
import { isDocumentTypeRecurringInvoice } from '@features/invoices/utils/isDocumentTypeRecurringInvoice'

import { invoiceEditorVariantDocumentTypes } from '../constants/variants/invoiceEditorVariantDocumentTypes'
import { useInvoiceEditor } from '../contexts/invoiceEditorContext'

export const useInvoiceEditorDocumentType = () => {
  const { invoiceEditorVariant } = useInvoiceEditor()

  const documentType = useMemo(() => {
    return invoiceEditorVariantDocumentTypes[invoiceEditorVariant].documentType
  }, [invoiceEditorVariant])

  const isInvoice = useMemo(() => {
    return isDocumentTypeInvoice(documentType)
  }, [documentType])

  const isCreditNote = useMemo(() => {
    return isDocumentTypeCreditNote(documentType)
  }, [documentType])

  const isQuote = useMemo(() => {
    return isDocumentTypeQuote(documentType)
  }, [documentType])

  const isRecurringInvoice = useMemo(() => {
    return isDocumentTypeRecurringInvoice(documentType)
  }, [documentType])

  const sourceDocumentType = useMemo(() => {
    return invoiceEditorVariantDocumentTypes[invoiceEditorVariant].sourceDocumentType
  }, [invoiceEditorVariant])

  return { documentType, isCreditNote, isInvoice, isQuote, isRecurringInvoice, sourceDocumentType }
}
